import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconNote1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"note-1"} maskId="square-filled-radius-0-stroke-1-IconNote1"><path fillRule="evenodd" clipRule="evenodd" d="M3 21V3H21V15H15V21H3Z" fill="currentColor"/><path d="M16 21H16.2071L21 16.2071V16H16V21Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconNote1;
